import { ViewChild } from '@angular/core';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { VendorTakeActionDomain } from '../model/af.model';
import { VendorService } from '../service/vendor.service';

@Component({
  selector: 'app-vendor-search-results-take-action',
  templateUrl: './vendor-search-results-take-action.component.html',
  styleUrls: ['./vendor-search-results-take-action.component.scss']
})
export class VendorSearchResultsTakeActionComponent implements OnInit {

  actionEmail: UntypedFormControl;
  entityId: string;
  applicantName: string;
  caseNumber: string;
  containerId: number;
  auditId: number;
  private sort: MatSort;
  private paginator: MatPaginator;
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.dataSource.paginator = this.paginator;
  }
  dataSource: MatTableDataSource<VendorTakeActionDomain>;
  displayedColumns: string[] = ['templateName', 'dateSent', 'sentTo', 'sentCC', 'sentBCC', 'resend'];

  constructor(@Inject(MAT_DIALOG_DATA) private vendorData: any,
    private vendorService: VendorService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<VendorTakeActionDomain>([]);
    this.applicantName = this.vendorData.applicantName;
    this.caseNumber = this.vendorData.caseNumber;
    this.containerId = this.vendorData.containerId;
    this.entityId = this.vendorData.entityId;
    this.auditId = this.vendorData.auditId;
    this.actionEmail = new UntypedFormControl('', Validators.email);

    this.dataSource.data = this.vendorData.tableDataSource;
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  onWithdrawCase() {
    this.vendorService.takeActionWithdraw(this.containerId).subscribe({
      next: (response: string) => {
        if (response != null && response != '') {
          this._snackBar.open("Case Withdrawn Successfully.", "Close", {
            duration: 4000,
            panelClass: ["custom-snack-bar"]
          });
        }
      },
      error: () => {
        this._snackBar.open("Case Withdraw Unsuccessfull.", "Close", {
          duration: 4000,
          panelClass: ["custom-error-bar"]
        });
      }
    });
  }

  onUpdateEmailAddress() {
    if (this.actionEmail.valid) {
      this.vendorService.vendorUpdateEmail(this.entityId, this.actionEmail.value.trim()).subscribe({
        next: (response: string) => {
          if (response == "SUCCESS") {
            this._snackBar.open("Updated Email Successfully.", "Close", {
              duration: 4000,
              panelClass: ["custom-snack-bar"]
            }
            );
          } else {
            this._snackBar.open("Email Update Unsuccessfull.", "Close", {
              duration: 4000,
              panelClass: ["custom-error-bar"]
            });
          }
        },
        error: () => {
          this._snackBar.open("Email Update Unsuccessfull. Server Error", "Close", {
            duration: 4000,
            panelClass: ["custom-error-bar"]
          });
        }
      });
    }
  }

  onResendEmail(auditId: string) {
    this.vendorService.resendEmail(auditId, this.caseNumber).subscribe({
      next: (response: string) => {
        if (response == "SUCCESS") {
          this._snackBar.open("Email Sent Successfully!", "Close", {
            duration: 4000,
            panelClass: ["custom-snack-bar"]
          });
        } else {
          this._snackBar.open("Email sent operation Unsuccessful! Please try again.", "Close", {
            duration: 4000,
            panelClass: ["custom-error-bar"]
          });
        }
      },
      error: () => {
        this._snackBar.open("Email sent operation Unsuccessful! Server Error.", "Close", {
          duration: 4000,
          panelClass: ["custom-error-bar"]
        });
      }
    });
  }
}
